// import { cssdApiClients, cssdApiClients } from "../../../http-common";
// import authHeader from "../../../authentication/authservices/auth-header";

import { cssdApiClients } from "../../../http-common";

import authHeader from "../../../authentication/authservices/auth-header";

export const fetchTransferCssdItemsListPrievous = async (data) => {
  return await cssdApiClients.post('/cssd/get/peviousRequestList', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const fetchTransferCssdItemsList = async (kitId, kitBatchNo) => {
  return await cssdApiClients.get(`/cssd/transfer/${kitId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};


export const fetchTransferCssdItemsListStock = async (kitId, kitBatchNo) => {
  return await cssdApiClients.get(`/cssd/transfer/${kitId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const fetchIndentData = async (data) => {
  return await cssdApiClients.post('/cssd/getIndentData', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const fetchBatchNoList = (batchCode) => {
  return cssdApiClients.get(`/cssd/search/batchNo/${batchCode}`, {
    headers: authHeader(),
  });
};

export const fetchTransferReceiveCssdItemsListOT = (id, kitBatchNo) => {
  return cssdApiClients.get(`/cssd/transfer/${id}`, {
    headers: authHeader(),
  });
};


export const fetchTransferReceiveCssdItemsList = async (issueId) => {
  return await cssdApiClients.get(`/cssd/getitemfromkit/issue/details/${issueId}`, {
    headers: authHeader(),
  });
};

export const fetchitemkfromkit = (id) => {
  return cssdApiClients.get(`/cssd/getitemfromkit/details/${id}`, {
    headers: authHeader(),
  });
};

export const fetchCssdKitItemById = (id) => {
  return cssdApiClients.get(`/cssd/kit/item/${id}`, {
    headers: authHeader(),
  });
};

export const fetchCssdStockByIdAndBatch = (id, kitBatchNo) => {
  return cssdApiClients.get(`/cssd/stock/${id}/${kitBatchNo}`, {
    headers: authHeader(),
  });
};

export const saveCssdIndentDetails = async (data) => {
  return await cssdApiClients.post('/cssd/insert/indents/details', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const saveTransferCssdItemsList = async (data) => {
  return await cssdApiClients.put('/cssd/update', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};


export const saveTransferCssdItemsParentList = async (data) => {
  return await cssdApiClients.put('/cssd/update/parent', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

// export const saveTransferCssdItemsList = async (data) => {
//   return await cssdApiClients.post('/cssd/insertTransferdata', data, {
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   });
// };

export const saveTransferCssdItemsListStock = async (data) => {
  return await cssdApiClients.post('/cssd/saveAll/StockData', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};


export const saveTransferCssdItemsListTransferOT = async (data) => {
  return await cssdApiClients.post('/cssd/insertTransferdata', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};


export const saveTransferCssdItemsListTransfer = async (data) => {
  return await cssdApiClients.post('/cssd/insert/issue/details', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};


// export const fetchCssdItems = (type) => {
//   return cssdApiClients.get(`/cssd/${type}`, {
//     headers: authHeader(),
//   });
// };

export const fetchCssdItems = (type, search) => {
  return cssdApiClients.get(`/cssd/${type}/${search}`, {
    headers: authHeader(),
  });
};


export const fetchCssdItemsTransferOT = (type) => {
  return cssdApiClients.get(`/cssd/getStockData/${type}`, {
    headers: authHeader(),
  });
};


// export const fetchTransferCssdItemsList = async (listObj) => {
//   return await cssdApiClients.post("/cssdtransfer/processCssdItems", listObj, {
//     headers: authHeader(),
//   });
// };

export const fetchTransferCssdItemsKitListCSSDRe = async (listObj) => {
  return await cssdApiClients.post("/cssd/processCssdItems", listObj, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const fetchTransferCssdItemsKitList = async (listObj) => {
  return await cssdApiClients.post("/cssd/getIssueData", listObj, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};


// export const saveTransferCssdItemsList = async (postObj) => {
//   return await cssdApiClients.put("/cssdtransfer/update", postObj, {
//     headers: authHeader(),
//   });
// };

export const getBatchWiseCssdKits = async (unitId, kitId) => {
  return await cssdApiClients.get(
    `/cssdtransfer/batchwiseCssdKits/${unitId}/${kitId}`,
    {
      headers: authHeader(),
    }
  );
};

export const getItemWiseBatchNoDropdown = async (itemId, storeId, unitId) => {
  return await cssdApiClients.get(
    `/itemstock/storeWiseDropdown/${itemId}/${storeId}/${unitId}`,
    {
      headers: authHeader(),
    }
  );
};


export const getpeviousRequestListdropdown = async (type, search) => {
  return await cssdApiClients.get(`/cssd/peviousRequestListdropdown/${type}/${search}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};



// export const getBatchwiseItemsForKit = async (
//   storeId,
//   unitId,
//   kitId,
//   kitBatchNo
// ) => {
//   return await cssdApiClients.get(
//     `/item/getBatchwiseItemsForKit/${storeId}/${unitId}/${kitId}/${kitBatchNo}`,
//     {
//       headers: authHeader(),
//     }
//   );
// };

// export const getWrapperTypeDropdown = async () => {
//   return await cssdApiClients.get("/cssd/wrappertypedropdown", {
//     headers: authHeader(),
//   });
// };

export const getWrapperTypeDropdown = (search) => {
  return cssdApiClients.get(`/cssd/wrappertypedropdown/${search}`, {
    headers: authHeader(),
  });
};

// export const getWrappingMethodDropdown = async () => {
//   return await cssdApiClients.get("/cssd/wrappingmethoddropdown", {
//     headers: authHeader(),
//   });
// };

export const getWrappingMethodDropdown = (search) => {
  return cssdApiClients.get(`/cssd/wrappingmethoddropdown/${search}`, {
    headers: authHeader(),
  });
};


export const getSterilizationTypeDropdown = async () => {
  return await cssdApiClients.get("/surgerydetails/sterilizationtypedropdown", {
    headers: authHeader(),
  });
};

// export const getSterilizationMethodDropdown = async () => {
//   return await cssdApiClients.get("/cssd/sterilizationmethoddropdown", {
//     headers: authHeader(),
//   });
// };

export const getSterilizationMethodDropdown = (search) => {
  return cssdApiClients.get(`/cssd/sterilizationmethoddropdown/${search}`, {
    headers: authHeader(),
  });
};

// export const getSterilizationMachineDropdown = async () => {
//   return await cssdApiClients.get("/cssd/sterilizationmachinedropdown", {
//     headers: authHeader(),
//   });
// };

export const getSterilizationMachineDropdown = (search) => {
  return cssdApiClients.get(`/cssd/sterilizationmachinedropdown/${search}`, {
    headers: authHeader(),
  });
};